import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Link,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AttachFileIcon from "@mui/icons-material/AttachFile";

function SupplierPenalty() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        height="60vh" // Make page take full height
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{ ...styles.add_form_page_container, mb: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
              <Typography sx={styles.supplier_sub_title_text}>
                Late Delivery Penalty
              </Typography>
            </Grid>
            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            >
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  label="Minimum Grace Period"
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Penalty Period</InputLabel>
                  <Select label="Penalty Period" defaultValue="d">
                    <MenuItem value="d">Daily</MenuItem>
                    <MenuItem value="m">Monthly</MenuItem>
                    <MenuItem value="w">Weekly</MenuItem>
                    <MenuItem value="c">Customize</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  label="Number of Days"
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  label="Penalty Charge"
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  label="Description"
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Box sx={styles.supplier_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default SupplierPenalty;
